import React from 'react';

const PromotionCouponFormModal = React.lazy(() => import('../components/FormModal'));
const promotionCouponModalRegistry = {
    core_promotionCouponId: PromotionCouponFormModal
};
export default promotionCouponModalRegistry;
